import axios from '@/helpers/axios';
import { authApi, orderApi } from '@/helpers/apis';
import TokenService from '@/helpers/tokenService';
import { isEmpowerFlow } from '@/helpers/common';
const mainaxios = require('axios');

const apigeeKey = process.env.GATSBY_APIGEE_KEY;
const urlencoded = new URLSearchParams();
urlencoded.append('grant_type', 'client_credentials');

export const requestToken = () => {
  const url = authApi.REQUEST_TOKEN;
  return axios.post(url, urlencoded, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Basic ${apigeeKey}`
    }
  });
};

export const registerDevice = () => {
  const url = authApi.MFA_REGISTER_DEVICE;
  const body = {
    client: 'ems',
    name: 'eShop2.0',
    model: 'web',
    manufacturer: 'web',
    os: 'web'
  };
  return axios.post(url, body);
};

export const fetchUDFToken = () => {
  const url = `${process.env.GATSBY_FETCH_TOKEN_URL}?email=xv.vishnupriya.bs@singtel.com`;
  return axios.get(url);
};

export const fetchChannelToken = () => {
  const url = `${process.env.GATSBY_ACCESS_TOKEN_URL}`;
  return axios.post(url);
};

export const fetchChannelToken2 = (access_token) => {
  const url = `${process.env.GATSBY_ACCESS_TOKEN_URL}`;
  return mainaxios.post(url, null, { headers: { Authorization: `${access_token}` } });
};

export const requestOTP = (email) => {
  const url = authApi.MFA_REQUEST_OTP;
  return axios.post(url, { email });
};

export const verifyOTP = (challengeToken, otp) => {
  const url = authApi.MFA_VERIFY_OTP;
  return axios.post(url, { challengeToken, code: otp });
};

export const pdpaRefreshToken = (key) => {
  const url = authApi.PDPA_REFRESHTOKEN;
  return axios.post(url, { encLink: key });
};

export const getAccountList = () => {
  const url = authApi.GET_AUTHENTICATE;
  return axios.get(url);
};

export const pdpaAuthenticate = (key, pdpaType = '') => {
  const url = authApi.PDPA_AUTHENTICATE;
  return axios.post(url, {
    encLink: key,
    esimFlow: (pdpaType === 'esim')
  });
};

export const customerValidate = (email) => {
  const url = authApi.CUSTOMER_VALIDATE;
  return axios.post(url, { email });
};

export const checkBrnBlacklisted = (reqPayload) => {
  const url = authApi.CHECK_BLACKLIST;
  return axios.post(url, reqPayload);
};

export const getConfiguredMstKeyValuesByBrn = (brn: string) => {
  const url = `${authApi.GET_CONFIG_BY_BRN}/${brn}`;
  return axios.post(url);
};

export const getGlobalConfigs = () => {
  const url = `${authApi.GET_OTHER_CONFIGS}`;
  return axios.get(url);
};

export const pdpaValidate = (key, isWaiver = false, pdpaType = '') => {
  const url = `${authApi.PDPA_VALIDATE}`;
  const payload: any = {
    encLink: key,
    waiverFlow: isWaiver,
    esimFlow: (pdpaType === 'esim')
  };
  if (!isWaiver) {
    delete payload.waiverFlow;
  }
  return axios.post(url, payload);
};

export const pdpaOrderDetails = (key) => {
  const url = `${orderApi.GET_PDPA_ORDER_DETAILS}`;
  return axios.post(url, { encLink: key });
};

export const getUserGroupPolicies = () => {
  const url = authApi.MYEMPOWER_USER_PERMISSION;
  return mainaxios.get(url, { headers: { Authorization: `Bearer ${TokenService.getLocalAccessToken()}` } });
};

export const getEmpowerUserGroupPolicies = () => {
  const url = authApi.EMPOWER_USER_PERMISSION;
  return axios.get(url);
};

export const getEmpowerUserDetails = () => {
  const url = authApi.EMPOWER_USER_DETAILS;
  return mainaxios.get(url, {
    headers: { Authorization: `Bearer ${TokenService.getLocalAccessToken()}`, 'x-customer-id': 0 }
  });
};

export const getRefreshToken = () => {
  if (isEmpowerFlow()) {
    return mainaxios.get(`${authApi.EMPOWER_REFRESH_TOKEN_URL}`, {
      headers: { Authorization: `Bearer ${TokenService.getLocalRefreshToken()}` }
    });
  }
  return mainaxios.get(`${process.env.GATSBY_REFRESH_TOKEN_URL}`, {
    headers: { Authorization: `Bearer ${TokenService.getLocalRefreshToken()}` }
  });
};

export const getStaffUserGroupPolicies = () => {
  return mainaxios.get(`${authApi.STAFF_USER_PERMISSION}`, {
    headers: { Authorization: `Bearer ${TokenService.getLocalAccessToken()}` }
  });
};

export const waiverValidate = (key) => {
  const url = `${authApi.APPROVE_VALIDATE}`;
  return axios.post(url, { encLink: key });
};
